import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import voca from 'voca';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import MuiButton from '@material-ui/core/Button';
import MuiGrid from '@material-ui/core/Grid';
import Link from 'next/link';
import Box from '@material-ui/core/Box';
import useStores from '../../../utils/useStores';
import Wrap from './Wrap';

const LogoDEPI = '/images/DEPI_Logo.svg';
const Sticker1 = '/images/DEPV_Logo.svg';
const Sticker2 = '/images/ENplus_Logo.svg';
const Sticker3 = '/images/ENplus_Logo_Hackschnitzel.svg';
const Sticker4 = '/images/ENplus_Logo_Holzbriketts.svg';
const Sticker5 = '/images/Logo_Fachstudio.svg';
const Sticker6 = '/images/Logo_Pelletfachbetrieb.svg';

const Sticker = props => {
  const { src, ...rest } = props;
  return (
    <Box mr={0.5} ml={0.5}>
      <a target="_blank" rel="noopener noreferer" {...rest}>
        <img src={src} width="100%" height="auto" />
      </a>
    </Box>
  );
};

const AboutSection = () => {
  const { dataStore } = useStores();
  const page = dataStore.pages.asList.find(
    p => p.uuid === '3a027484-274b-4a22-bfcf-17e3b4eb7c27',
  );

  if (!page) return null;

  const abstract = voca.prune(page.data.abstract, 400, ' ...');
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;

  return (
    <Wrap bgcolor="common.white">
      <Typography variant="h2" data-underline>
        Über das DEPI
      </Typography>
      <MuiGrid container spacing={2}>
        <MuiGrid item xs={2} sm={true} />
        <MuiGrid item xs={8} sm={3}>
          <Box textAlign="center">
            <img width="100%" height="auto" src={LogoDEPI} />
          </Box>
        </MuiGrid>
        <MuiGrid item xs={2} sm={true} />
        <MuiGrid item xs={12} sm={8}>
          <Typography variant="h6" color="textPrimary" gutterBottom>
            {abstract}
          </Typography>
        </MuiGrid>
        <MuiGrid item xs={true} sm={1} />
      </MuiGrid>
      <Box display="flex" justifyContent="center" mt={6}>
        <Link
          href={`${linkContext}[...pageId]`}
          as={`${linkContext}ueber-das-depi`}
          passHref
        >
          <MuiButton size="large" variant="outlined">
            Mehr über das DEPI
          </MuiButton>
        </Link>
      </Box>
      <Box display="flex" alignItems="center" mt={6}>
        <Sticker href="https://depv.de" src={Sticker1} />
        <Sticker href="https://enplus-pellets.de" src={Sticker2} />
        <Sticker href="https://enplus-hackschnitzel.de" src={Sticker3} />
        <Sticker href="https://enplus-briketts.de" src={Sticker4} />
        <Sticker
          href="https://depi.de/de/pelletfachbetriebe-und-ofenstudios"
          src={Sticker5}
        />
        <Sticker
          href="https://depi.de/de/pelletfachbetriebe-und-ofenstudios"
          src={Sticker6}
        />
      </Box>
    </Wrap>
  );
};

export default observer(AboutSection);
